import { ChangeDetectionStrategy, Component, OnInit, effect, inject } from '@angular/core';
import { DatoGeograficoCementoApiService } from '../../../services/dato-geografico-cemento-api.service';
import { DatosGeograficosCementoStore } from '../../../stores/datos-geograficos-cemento.store';
import { DatosGeograficosCementoUiEffectsService } from '../ui-effects/datos-geograficos-cemento-ui-effects.service';

@Component({
  selector: 'app-datos-geograficos-cemento-page',
  templateUrl: './datos-geograficos-cemento-page.component.html',
  styleUrls: ['./datos-geograficos-cemento-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DatoGeograficoCementoApiService,
    DatosGeograficosCementoStore,
    DatosGeograficosCementoUiEffectsService,
  ],
})
export class DatosGeograficosCementoPageComponent implements OnInit {
  readonly store = inject(DatosGeograficosCementoStore);
  private readonly uiEffects = inject(DatosGeograficosCementoUiEffectsService);

  constructor() {
    effect(() => {
      this.uiEffects.syncLoading(this.store.loading());
    });
  }

  ngOnInit(): void {
    this.store.loadItems().subscribe({
      error: () => {
        this.uiEffects.showLoadError();
      },
    });
  }
}
